var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-overlay',{attrs:{"value":_vm.loading,"attach":"body","opacity":"0.9"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }